import React, { useState } from 'react';
import { Field, Form, Formik } from 'formik';
import FormFieldWithLabel from '../../common/FormFieldWithLabel';
import { getFieldInfoByName } from '../../events/action/collection/Util';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { snakeCaseToTitleCase } from '../../../common/utils/api_utils';
import CustomSelect from '../../../common/formElements/CustomSelect';
import { generateUrl } from '../../../common/utils/environments';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import voca from 'voca';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export const UserTokenForm = ({ projectId, environments, projectDetail, user, setUser }) => {
  const clipboardStyle = {
    cursor: 'pointer',
    padding: '4px',
    verticalAlign: 'middle',
    margin: 0,
  };

  const environmentsOptions = environments
    ? environments.map((env) => ({
        label: snakeCaseToTitleCase(env.envType),
        value: env.envType,
      }))
    : [];

  const [env, setEnv] = useState('');
  const [loginUrl, setLoginUrl] = useState('');

  const copyToClipboard = (token) => {
    if (token) toast.success('Copied to clipboard');
  };

  const handleEnvChange = (name, value) => {
    if (value) {
      setEnv(value);
      const baseUrl = generateUrl(projectDetail, value);
      setLoginUrl(`${baseUrl}auth/login`);
    }
  };

  const handleSubmit = async (values) => {
    const { userName, password } = values;
    const headers = builderSurfaceJsonContentHeader(projectId);
    const res = await axios.post(loginUrl, { userName, password }, headers);
    if (res.status === 200) {
      const {
        data: {
          token,
          expiresIn,
          userDetails: { userName },
        },
      } = res;
      setUser({ token, expiresIn, userName });
    }
  };

  if (user) {
    const { token, expiresIn, userName } = user;
    return (
      <>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <strong>Username: </strong>&nbsp;
            <span>{userName}</span>
          </div>
        </div>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <strong>Expires In: </strong>&nbsp;
            <span>{expiresIn}</span>
          </div>
        </div>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
            <strong>User Token: </strong>&nbsp;
            <CopyToClipboard
              text={token}
              onCopy={() => copyToClipboard(token)}
              title={'Copy to clipboard'}
              style={clipboardStyle}
            >
              <span>
                {voca.first(token, 35)}...
                {voca.last(token, 30)} <i className="webconnect webconnect-files" />
              </span>
            </CopyToClipboard>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <Formik initialValues={{}} onSubmit={handleSubmit}>
        {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
          return (
            <Form className="form-horizontal">
              <div className="row mx-auto">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Username"
                      icon="text"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('userName')}
                    >
                      <Field
                        type="text"
                        name="userName"
                        placeholder="Username"
                        className="form-control form-control-sm"
                      />
                    </FormFieldWithLabel>
                  </div>
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Password"
                      icon="password"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('password')}
                    >
                      <Field
                        type="password"
                        name="password"
                        placeholder="Password"
                        className="form-control form-control-sm"
                      />
                    </FormFieldWithLabel>
                  </div>
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Environment"
                      icon="select"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('environments')}
                    >
                      <CustomSelect
                        name={'environments'}
                        isMulti={false}
                        value={env}
                        options={environmentsOptions}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        onChangeValue={handleEnvChange}
                      />
                    </FormFieldWithLabel>
                  </div>
                </div>
                <div className="col-md-12 col-lg-12 mt-2 text-right">
                  <button type="submit" className="btn btn-theme-submit btn-md">
                    <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Generate Token&nbsp;
                  </button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  }
};
